export function toggleAccordion() {
  const accordions = document.getElementsByClassName('accordion_link__container');
  const isContent = document.querySelector('.content__wrapper');

  Array.from(accordions).forEach((accordionLinkContainer) => {
    accordionLinkContainer.querySelector('.accordion_link__header').addEventListener('click', () => {
      let remove = false;

      if (accordionLinkContainer.classList.contains('show')) remove = true;

      // Remove all SHOW's from the dom, then add the one we want.
      Array.from(accordions).forEach((accordionLinkRemove) => {
        accordionLinkRemove.classList.remove('show');
        accordionLinkContainer.querySelector('.accordion_link__header').setAttribute('aria-expanded', 'false');
      });

      accordionLinkContainer.classList.toggle('show');
      accordionLinkContainer.querySelector('.accordion_link__header').setAttribute('aria-expanded', 'true');
      if (isContent) accordionLinkContainer.querySelector('.anchor-heading').scrollIntoView();

      // remove the arrow if clicking on an accordion which is already showing.
      if (remove) {
        accordionLinkContainer.classList.remove('show');
        accordionLinkContainer.querySelector('.accordion_link__header').setAttribute('aria-expanded', 'false');
      }
    });
  });

  // Close accordions if an accordion is clicked off
  document.addEventListener('click', (e) => {
    // Make sure we're not clicking on an anchor item because that may open an accordion
    const anchorMenu = Array.from(document.getElementsByClassName('anchor-menu__link'));
    const anchorClicked = anchorMenu.some((anchor) => anchor.contains(e.target));

    if (accordions.length && !anchorClicked) {
      const accordionArray = Array.from(accordions);
      // Was any of the accordions on the page a click target?
      const accordionClicked = accordionArray.some((accordion) => accordion.contains(e.target));
      if (!accordionClicked) {
        accordionArray.forEach((accordionLinkRemove) => {
          accordionLinkRemove.classList.remove('show');
          accordionLinkRemove.querySelector('.accordion_link__header').setAttribute('aria-expanded', 'false');
        });
      }
    }
  });
}

export default toggleAccordion;
